import { createRoute, Outlet } from "@tanstack/react-router";
import { memo } from "react";
import { accountRoutes } from "../../App";
import { ContactSales } from "./ContactSales";
import { ContactLayout } from "../../layouts/ContactLayout";

const accountContactLayoutRoute = createRoute({
  getParentRoute: () => accountRoutes,
  id: "contact",
  component: memo(() => {
    return (
      <ContactLayout>
        <Outlet />
      </ContactLayout>
    );
  }),
});

const subscriptionContactSalesRoute = createRoute({
  getParentRoute: () => accountContactLayoutRoute,
  path: "/contact/sales",
  component: ContactSales,
});

export const accountContactRoutes = accountContactLayoutRoute.addChildren([
  subscriptionContactSalesRoute,
]);
